<div class="avatar-upload">
  <div class="avatar-capture-camera" [title]="'RESUME.Capture photo by camera'|translate"
    [ngStyle]="{'justify-content':(form_group.get(field.fieldID).value && form_group.get(field.fieldID).value !='')?'space-around':'flex-start'}">
    <i class="fa fa-camera pointer camera-icon " (click)="setupDevices({isCamShot : true})"></i>

    <i class="fa fa-trash orange pointer camera-icon " [title]="'RESUME.delete'|translate"
      *ngIf="form_group.get(field.fieldID).value && form_group.get(field.fieldID).value !=''"
      (click)="removeUploadedFile()"></i>

  </div>
  <div class="avatar-edit">
    <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="fileInputChanged($event)" />

  </div>
  <div class="avatar-preview" [style.height.px]="100" [style.width.px]="100">
    <span *ngIf="form_group.get(field.fieldID).value" class="delete-profile">
      <i class="fa fa-pencil pointer delete-icon" (click)="fileInput.click()">
      </i>
      <div class="overlay"></div>
    </span>

    <ng-container
      *ngIf="form_group.get(field.fieldID).value && form_group.get(field.fieldID).value[0] && form_group.get(field.fieldID).value[0].cdnPath; else elseTemplate">

      <div class="jump" (click)="fileInput.click()" id="imagePreview"
        [style.backgroundImage]="'url('+ storage_url + form_group.get(field.fieldID).value[0].cdnPath +')'">
      </div>
    </ng-container>
    <ng-template #elseTemplate>

      <div class="jump" (click)="fileInput.click()" *ngIf="form_group.get(field.fieldID).value" id="imagePreview"
        [style.backgroundImage]="'url('+form_group.get(field.fieldID).value +')'">
      </div>
    </ng-template>


    <div (click)="fileInput.click()" *ngIf="!form_group.get(field.fieldID).value" id="imagePreviewDefault">
    </div>
  </div>
</div>
